<ftr-page [pageStyle]="pageStyle">
  @if (isHandlingNativeAuth) {
    <ftr-loader [isLoading]="true" [fullPage]="true" [loaderText]="'Redirecting to ' + identityProvider + '...'" />
  } @else {
    <article class="login-component" [class.login-component--bordered]="mode !== 'legacy'">
      <div class="card card--borderless card--shadowless password-card">
        @if (isAccessingSharedAudio) {
          <div class="login__shared-audio-notification">
            <ftr-alert type="info" class="block my-4" [renderAsMarkdown]="true">
              Please either log in, or sign up with For The Record to be able to access the shared link
            </ftr-alert>
          </div>
        }
        <header class="login__header">
          @if (loginConfig().icon && loginConfig().badgeColor) {
            <ftr-badge [icon]="loginConfig().icon!" [color]="loginConfig().badgeColor!" displayType="tile" />
          }
          <h1>{{ loginConfig().title }}</h1>
          <p>{{ loginConfig().subTitle }}</p>
        </header>
        <ftr-notification-flash />
        <ftr-login-form [returnUrl]="returnUrl" />
        <ftr-divider [loose]="true">OR</ftr-divider>
        <ftr-single-sign-on [returnUrl]="returnUrl" [showMockLogin]="showMockLogin" />
        <div class="login__sign-up-container">
          Don't have an account?
          <a [routerLink]="['/signup']" [queryParams]="{ returnUrl: returnUrl }" queryParamsHandling="merge">
            Create account
          </a>
        </div>
        <div class="login__instructions">
          <a ftrElevioTrigger articleId="5">How do I create an account?</a>
        </div>
      </div>
    </article>
  }
</ftr-page>
